import React from "react";
import { stepThreeData } from "./stepsData";
import { Typography } from "@mui/material";

const StepThree = () => {
  return (
    <>
      <div id="step_two_data">
        <div className="content mt-4 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "24px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepThreeData[0].heading}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
            }}
          >
            {stepThreeData[0].subtitle}
          </Typography>
        </div>
        <div className="">
          <ul style={{ listStyle: "disc" }} className=" reviews_lists archivo">
            {stepThreeData[0].eligibilityList &&
              stepThreeData[0].eligibilityList.map((item, index) => (
                <li key={index} className="">
                  {" "}
                  <strong>{item.head} </strong>
                  {item.info}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default StepThree;
